export default __webpack_public_path__ + "static/broadcastImg4-bd052e35fc8e5cbc0c4e3867b38c0309.webp";